import '~/assets/css/snui/index.scss'
import components from '~/components/snui/v2/components'

/** @type {Vue.PluginObject<null>} */
const snui = {
  install (Vue) {
    Vue.mixin({
      components
    })
  }
}

export default snui
